module.exports = __webpack_public_path__ + "img/vntrip.527ad2ed.png";